import { render, staticRenderFns } from "./RegisteredCam.vue?vue&type=template&id=6dccb67c"
import script from "./RegisteredCam.vue?vue&type=script&lang=js"
export * from "./RegisteredCam.vue?vue&type=script&lang=js"
import style0 from "./RegisteredCam.vue?vue&type=style&index=0&id=6dccb67c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSpacer,VTextField})
